import { object, string } from 'yup';

const loginSchema = object({
  userName: string().required().matches(/^\S+$/, 'username must not contain whitespace'),
});

export default loginSchema;
